export default __webpack_public_path__ + "static/media/banner.0272cec2.jpg";